export const PLUGIN_KEY = 'aks-insert-ai-content';

export enum AksInsertAiContentButton {
  InsertAiContent = 'aks-insert-ai-content',
}

export const liftCodeApplicableCountries = [
  'France',
  'Germany',
  'Austria',
  'Belgium',
  'Spain',
  'Italy',
  'Netherlands',
  'United Kingdom',
];

export const campaignApplicableLanguages = ['fr', 'de', 'en', 'es', 'it']